<div class="container">
  <div class="content">
    <div class="template-main-content">
      <div class="side-nav neo-scrollbar">
        <div class="neo-tabs vertical">
          <div class="neo-tab" [class.active]="currentTab() === 'organization-settings'"
            (click)="switchCurrentTab('organization-settings')">
            Organization Settings
          </div>
          <div *ngIf="userPrivileges.has('branch.view')" class="neo-tab" [class.active]="currentTab() === 'branch-settings'"
            (click)="switchCurrentTab('branch-settings')">
            Branch Settings
          </div>
        </div>
      </div>
      <div class="template-details" [class.overflow-hidden]="currentTab() === 'branch-settings'" [class.remove-padding]="currentTab() === 'branch-settings'">
        @if (currentTab() === "organization-settings" && userInfo.length) {
        <div class="template-content neo-scrollbar">
          <div class="section">
            <div class="section-heading">
              Basic Details
            </div>
            <div class="section-content">
              <div class="section-item no-border">
                <div class="section-item-content" [formGroup]="companyDetails" *ngIf="userInfo.length">
                  <div class="neo-input-wrapper">
                    <label for="company_name" required>Company Name</label>
                    <input pInputText type="text" name="company_name" id="company_name"
                      [readonly]="!userPrivileges.has('company_details.update')" formControlName="name" [(ngModel)]="companyName">
                  </div>
                  <div class="neo-grid neo-grid-cols-2">
                    <div class="neo-input-wrapper" style="position: relative;">
                      <label for="company_industry" required>Industry</label>
                      <!-- <input pInputText type="text" name="company_industry" id="company_industry"
                        [readonly]="!userPrivileges.has('company_details.update')" formControlName="industry" [(ngModel)]="industry"> -->

                        <span class="p-input-icon-right p-float-label companyForm-elements">
                          <input [ngClass]="{ 'p-filled': industry }" style="width: 100%" type="text" pInputText
                            inputId="company_industry" formControlName="industry" [(ngModel)]="industry" (click)="industryOverlayNew.toggle($event)"
                            [style]="{ cursor: 'pointer' }" [readonly]="!userPrivileges.has('company_details.update')" />
                          <em class="pi pi-angle-down dropdown" style="position: absolute; right: 12px; top: 20px;"></em>
                          <p-popover #industryOverlayNew styleClass="no-padding-overlay">
                            <ng-template #content>
                              <div *ngFor="let field of industryList">
                                <p (click)="industry = field.label; industryOverlayNew.hide(); companyDetails.get('industry')?.setValue(field.label); companyDetails.get('industry')?.markAsDirty()"
                                  (keydown)="industry = field.label; industryOverlayNew.hide()" class="department-options">
                                  {{ field.label }}
                                </p>
                              </div>
                            </ng-template>
                          </p-popover>
                        </span>
                    </div>
                    <div class="neo-input-wrapper" style="position: relative;">
                      <label for="company_category" required>Category</label>
                      <!-- <input pInputText type="text" name="company_category" id="company_category"
                        [readonly]="!userPrivileges.has('company_details.update')" formControlName="company_category" [(ngModel)]="companyCategory"> -->
                      
                        <span class="p-input-icon-right p-float-label companyForm-elements">
                          <input [ngClass]="{ 'p-filled': companyCategory }" style="width: 100%" type="text" pInputText inputId="company_category"
                            formControlName="company_category" [(ngModel)]="companyCategory" (click)="companyCategoryOverlayNew.toggle($event)"
                            [style]="{ cursor: 'pointer' }" [readonly]="!userPrivileges.has('company_details.update')" />
                          <em class="pi pi-angle-down dropdown" style="position: absolute; right: 12px; top: 20px;"></em>
                          <p-popover #companyCategoryOverlayNew styleClass="no-padding-overlay">
                            <ng-template #content>
                              <div *ngFor="let field of companyCategoryList">
                                <p (click)="companyCategory = field; companyCategoryOverlayNew.hide(); companyDetails.get('company_category')?.setValue(field); companyDetails.get('company_category')?.markAsDirty()"
                                  (keydown)="companyCategory = field; companyCategoryOverlayNew.hide()" class="department-options">
                                  {{ field }}
                                </p>
                              </div>
                            </ng-template>
                          </p-popover>
                        </span>
                    </div>
                  </div>
                  <div class="neo-grid neo-grid-cols-2">
                    <div class="neo-input-wrapper">
                      <label for="company_pan_number">PAN Number</label>
                      <input pInputText type="text" name="company_pan_number" id="company_pan_number"
                        [readonly]="!userPrivileges.has('company_details.update')" formControlName="pan" [(ngModel)]="panNumber">
                    </div>
                    <div class="neo-input-wrapper">
                      <label for="company_gst_number">GST Number</label>
                      <input pInputText type="text" name="company_gst_number" id="company_gst_number"
                        [readonly]="!userPrivileges.has('company_details.update')" formControlName="gst" [(ngModel)]="gstNumber">
                    </div>
                  </div>
                  <div class="neo-input-wrapper">
                    <label for="company_tin_number">TIN Number</label>
                    <input pInputText type="text" name="company_tin_number" id="company_tin_number"
                      [readonly]="!userPrivileges.has('company_details.update')" formControlName="tin" [(ngModel)]="tinNumber">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="section">
            <div class="section-heading">
              Date & Time Details
            </div>
            <div class="section-content">
              <div class="section-item no-border" [formGroup]="companyDetails" *ngIf="userInfo.length">
                <div class="section-item-content">
                  <div class="neo-grid neo-grid-cols-2">
                    <div class="neo-input-wrapper" style="position: relative;">
                      <label for="company_date_format" required>Date Format</label>
                      <span class="p-input-icon-right p-float-label companyForm-elements">
                          <input style="width: 100%" type="text" pInputText inputId="date_dropdown"
                            formControlName="date_format" [(ngModel)]="companyData.date_format" (click)="dateOverlay.toggle($event)"
                            [style]="{ cursor: 'pointer' }" [readonly]="!userPrivileges.has('date_time_format.update')" />
                          <em class="pi pi-angle-down dropdown" style="position: absolute; right: 12px; top: 20px;"></em>
                          <p-popover #dateOverlay styleClass="no-padding-overlay">
                            <ng-template #content>
                              <div *ngFor="let field of dateList">
                                <p (click)="companyData.date_format = field.name; dateOverlay.hide(); companyDetails.get('date_format')?.setValue(field.value); companyDetails.get('date_format')?.markAsDirty()" class="department-options">
                                    {{ field.name }}
                                </p>
                              </div>
                            </ng-template>
                          </p-popover>
                        </span>
                      <!-- <input pInputText type="text" name="company_date_format" id="company_date_format"
                        [readonly]="!userPrivileges.has('date_time_format.update')" formControlName="date_format" [(ngModel)]="companyData.date_format"> -->
                    </div>
                    <div class="neo-input-wrapper" style="position: relative;">
                      <label for="company_time_format" required>Time Format</label>
                      <span class="p-input-icon-right p-float-label companyForm-elements">
                          <input style="width: 100%" type="text" pInputText inputId="time_dropdown"
                            [value]="getTimeFormatLabel()" (click)="timeoverlay.toggle($event)"
                            [style]="{ cursor: 'pointer' }" [readonly]="!userPrivileges.has('date_time_format.update')" />
                          <em class="pi pi-angle-down dropdown" style="position: absolute; right: 12px; top: 20px;"></em>
                          <p-popover #timeoverlay styleClass="no-padding-overlay">
                            <ng-template #content>
                              <div *ngFor="let field of timeList">
                                <p (click)="companyData.time_format = field.value; timeoverlay.hide(); companyDetails.get('time_format')?.setValue(field.value); companyDetails.get('time_format')?.markAsDirty()" class="department-options">
                                    {{ field.name }}
                                </p>
                              </div>
                            </ng-template>
                          </p-popover>
                        </span>
                      <!-- <input pInputText type="text" name="company_time_format" id="company_time_format"
                        [readonly]="!userPrivileges.has('date_time_format.update')" formControlName="time_format" [(ngModel)]="companyData.time_format"> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="section">
            <div class="section-heading">
              Branding Assets Details
            </div>
            <div class="section-content">
              <div class="section-item no-border">
                <div class="section-item-content">
                  <div class="assets-container">
                    <div class="assets-title">
                      Company Logo
                    </div>
                    <div class="assets-content">
                      <div class="assets-image">
                        <img [src]="logoSrcEdit" alt="company logo" />
                      </div>
                      <div class="assets-action">
                        <div class="assets-action-button">
                          <input #company_logo_file type="file" name="company_logo_file" id="company_logo_file" [accept]="'image/*'"
                            [multiple]="false" (change)="handleUpload($event, 'logo')" style="display: none;">
                          <button class="create-btn" pButton *ngIf="userPrivileges.has('company_details.update')" [disabled]="!userPrivileges.has('company_details.update')"
                            (click)="company_logo_file.click()">Upload
                            New</button>
                          <!-- <button class="delete-btn" pButton [disabled]="!userPrivileges.has('company_details.update')"
                            (click)="deleteFile('logo')">Delete</button> -->
                        </div>
                        <div class="assets-action-description">
                          Recommended SVG, PNG, JPG, JPEG or GIF Only (Max File Size : 800*400 PX)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="section-item no-border">
                <div class="section-item-content">
                  <div class="assets-container">
                    <div class="assets-title">
                      Cover Image
                    </div>
                    <div class="assets-content">
                      <div class="assets-image">
                        <img [src]="coverImageSrcEdit" alt="Cover Image" />
                      </div>
                      <div class="assets-action">
                        <div class="assets-action-button">
                          <input #company_cover_file type="file" name="company_cover_file" id="company_cover_file" [accept]="'image/*'"
                            [multiple]="false" (change)="handleUpload($event, 'cover')" style="display: none;">
                          <button class="create-btn" *ngIf="userPrivileges.has('company_details.update')" pButton [disabled]="!userPrivileges.has('company_details.update')"
                            (click)="company_cover_file.click()">Upload
                            New</button>
                          <!-- <button class="delete-btn" pButton [disabled]="!userPrivileges.has('company_details.update')"
                            (click)="deleteFile('cover')">Delete</button> -->
                        </div>
                        <div class="assets-action-description">
                          Recommended SVG, PNG, JPG, JPEG or GIF Only (Max File Size : 1920*1080 PX)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="section-item no-border">
                <div class="section-item-content">
                  <div class="assets-container">
                    <div class="assets-title">
                      Favicon
                    </div>
                    <div class="assets-content">
                      <div class="assets-image">
                        <img [src]="faviconSrcEdit" alt="Favicon" />
                      </div>
                      <div class="assets-action">
                        <div class="assets-action-button">
                          <input #company_favicon_file type="file" name="company_favicon_file" id="company_favicon_file" [accept]="'image/*'"
                            [multiple]="false" (change)="handleUpload($event, 'fav_icon')" style="display: none;">
                          <button class="create-btn" *ngIf="userPrivileges.has('company_details.update')" pButton [disabled]="!userPrivileges.has('company_details.update')"
                            (click)="company_favicon_file.click()">Upload
                            New</button>
                          <!-- <button class="delete-btn" pButton [disabled]="!userPrivileges.has('company_details.update')"
                            (click)="deleteFile('fav_icon')">Delete</button> -->
                        </div>
                        <div class="assets-action-description">
                          Recommended SVG, PNG, JPG, JPEG or GIF Only (Max File Size : 96*96 PX)
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        }
        @if (currentTab() === "branch-settings") {
        <app-branches></app-branches>
        }
      </div>
    </div>
    @if (currentTab() === "organization-settings" && userPrivileges.has('company_details.update')) {
    <div class="template-footer">
      <button class="create-btn" [disabled]="!userPrivileges.has('company_details.update')" pButton
        (click)="saveCompanyDetails()" [disabled]="saveBtnLoading" [loading]="saveBtnLoading">
        Save Changes
      </button>
      <!-- @if (currentTab() === "branch-settings") {
            <button class="delete-btn" [disabled]="!userPrivileges.has('branch.delete')" pButton>
              Delete
            </button>
            <button class="create-btn" [disabled]="!userPrivileges.has('branch.update')" pButton>
              Save Changes
            </button>
            } -->
    </div>
    }
  </div>
</div>

<div *ngIf="loadingCompanyDetails" class="loadingOverlay center-loader">
  <p-progressSpinner [style]="{height: '30px', width: '30px'}"  strokeWidth="7" animationDuration="0.5s">
  </p-progressSpinner>
</div>

<p-toast></p-toast>